import React, { createContext, useContext } from 'react';
import { IMAGE_MIME } from '@anytag/shared-constants';
import { useAIAssistantToaster, useAIAssistantManageFiles } from './hook';

export type ChatRoomContextType = ReturnType<typeof useAIAssistantToaster> &
  ReturnType<typeof useAIAssistantManageFiles>;

const ChatRoomContext = createContext<ChatRoomContextType>({} as ChatRoomContextType);

export interface ChatRoomProviderProps {
  children: React.ReactElement | Array<React.ReactElement>;
}

export const ChatRoomProvider = ({ children }: ChatRoomProviderProps) => {
  const toastStates = useAIAssistantToaster();
  const fileStates = useAIAssistantManageFiles({
    uploadFileConfigs: {
      multiple: false, // Support single upload for now
      accept: IMAGE_MIME // Only support upload image for now
    },
    setToastMessage: toastStates.setToastMessage
  });

  return <ChatRoomContext.Provider value={{ ...toastStates, ...fileStates }}>{children}</ChatRoomContext.Provider>;
};

export const useChatRoomContext = () => useContext<ChatRoomContextType>(ChatRoomContext);
